import { render, staticRenderFns } from "./xmzbYjzlInner.vue?vue&type=template&id=6256e220&scoped=true"
import script from "./xmzbYjzlInner.vue?vue&type=script&lang=js"
export * from "./xmzbYjzlInner.vue?vue&type=script&lang=js"
import style0 from "./xmzbYjzlInner.vue?vue&type=style&index=0&id=6256e220&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6256e220",
  null
  
)

export default component.exports